import { AdminShell } from '@/features/admin/components/admin-shell.js';
import { InstallDialog } from '@/features/admin/components/tenant-templates/install-dialog.js';
import { TenantTemplatesList } from '@/features/admin/components/tenant-templates/tenant-templates-list.js';
import { useAuth } from '@/lib/auth/use-auth.js';
import { tokens } from '@/lib/tokens.js';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/_admin/tenant-templates')({
  component: TenantTemplatesPage,
});

function TenantTemplatesPage() {
  const { user } = useAuth();
  const [showInstall, setShowInstall] = useState(false);
  const tenantId = user?.tenant ?? '';

  return (
    <AdminShell currentPath="/tenant-templates">
      <div>
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: tokens.colors.textDark,
            marginBottom: '1.5rem',
          }}
        >
          Tenant Installations
        </h1>
        <TenantTemplatesList tenantId={tenantId} onInstallClick={() => setShowInstall(true)} />
      </div>

      {showInstall && <InstallDialog tenantId={tenantId} onClose={() => setShowInstall(false)} />}
    </AdminShell>
  );
}
